import React, {useState} from 'react';
import './MaintenanceScreen.css';
import {PolygonSpinner} from "./PolygonSpinner";

export const MaintenanceScreen = () => {
    const [showSpinner, setShowSpinner] = useState(true);
    const handleSpinnerComplete = () => {
        setShowSpinner(false);
    };

    return (
        <div className="blocked-container">
            <div className="blocked-content">
                {/* Иконка - вы можете заменить на свою */}
                <svg
                    className="blocked-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.41 0 8 3.59 8 8 0 1.85-.63 3.55-1.69 4.9z"
                        fill="currentColor"
                    />
                </svg>
                {/*<div className="app-container spinner-fullscreen">*/}
                {/*    <PolygonSpinner />*/}

                {/*</div>*/}

                <h1 className="blocked-title">Технические работы</h1>

                <p className="blocked-description">
                    Ведутся технические работы.<br />
                    Пожалуйста, попробуйте позже.
                </p>
            </div>
        </div>
    );
};